import styled from 'styled-components';
import { CenterLoader } from '@linearb/linui-common';

const CenteredLoader = styled(CenterLoader)`
  width: 30rem;
  padding: 10rem;
`;

export default CenteredLoader;
